/**
 * Splits a skill file into its frontmatter lines (kept as written, so fields this screen does not
 * edit survive a save) and its body. Title and description come out as plain values.
 */
const parseSkillDocument = (content) => {
  const text = String(content || '');
  const closing = text.startsWith('---\n') ? text.indexOf('\n---\n', 4) : -1;

  if (closing < 0) {
    return { title: '', description: '', otherLines: ['kind: skill'], body: text };
  }

  const lines = text.slice(4, closing).split('\n');
  const readValue = (key) => {
    const line = lines.find((candidate) => candidate.startsWith(`${key}:`));
    return line
      ? line
          .slice(key.length + 1)
          .trim()
          .replace(/^(['"])(.*)\1$/, '$2')
      : '';
  };

  return {
    title: readValue('title'),
    description: readValue('description'),
    otherLines: lines.filter((line) => line.trim() && !line.startsWith('title:') && !line.startsWith('description:')),
    body: text.slice(closing + 5)
  };
};

export default parseSkillDocument;
